import { render, staticRenderFns } from "./IniciarDropdownGDI.vue?vue&type=template&id=1edd5e1c&scoped=true&"
import script from "./IniciarDropdownGDI.vue?vue&type=script&lang=js&"
export * from "./IniciarDropdownGDI.vue?vue&type=script&lang=js&"
import style0 from "./IniciarDropdownGDI.vue?vue&type=style&index=0&id=1edd5e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd5e1c",
  null
  
)

export default component.exports